import { render } from "./Antrian.html?vue&type=template&id=f95d2e86&ts=true&external"
import script from "./Antrian.ts?vue&type=script&lang=ts&external"
export * from "./Antrian.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__